import { useVisitIntakeForms } from 'api/VisitIntakeForm'
import { Section } from '../Shared/Section'
import { useParams } from 'react-router-dom'
import { DateTime } from 'luxon'
import { PaginatedMiniList } from 'ui/components/PaginatedMiniList'
import { ChevronRightIcon, ExclamationCircleIcon } from '@heroicons/react/outline'
import {
  IntakeFormStatusTag,
  ViewAnswersButton,
} from 'screens/OrderDetails/components/IntakeForms/IntakeForms'
import { Spinner } from 'ui/components/Spinner'
import { EmptyState } from 'ui/components/EmptyState'

const Form = ({ form }) => (
  <li className="text-sm">
    <ViewAnswersButton
      visitIntakeFormId={form.id}
      completedAt={form.completed_at}
      buttonComponent={({ onClick, isLoading }) => (
        <button
          className="w-full p-3 hover:bg-gray-50 flex items-center justify-between text-left"
          onClick={onClick}
        >
          <div className="flex-1 space-y-1">
            <div className="text-gray-500">
              Completed on{' '}
              {DateTime.fromJSDate(form.completed_at).toLocaleString(DateTime.DATETIME_FULL)}{' '}
              {form.anonymised_at && (
                <IntakeFormStatusTag
                  completedAt={form.completed_at}
                  anonymisedAt={form.anonymised_at}
                />
              )}
            </div>
          </div>
          <div className="flex-shrink-0 text-gray-500">
            {isLoading ? <Spinner /> : <ChevronRightIcon className="w-6 h-6" />}
          </div>
        </button>
      )}
    />
  </li>
)

export const MandatoryWaiver = () => {
  const { clientId } = useParams()

  const {
    isLoading,
    isError,
    isSuccess,
    data: { data: forms = [], meta } = {},
  } = useVisitIntakeForms({
    customerId: clientId,
    type: 'mandatory',
  })

  return (
    <Section title="Mandatory waiver">
      {isSuccess && forms.length > 0 && (
        <PaginatedMiniList
          isLoading={isLoading}
          isError={isError}
          borderless
          rows={forms.map((form) => (
            <Form form={form} key={form.id} />
          ))}
        />
      )}

      {isSuccess && forms.length === 0 && (
        <EmptyState
          icon={ExclamationCircleIcon}
          title="This client hasn't filled out the mandatory waiver yet"
        />
      )}
    </Section>
  )
}
